// A PARTNER feature-jogai a `/portal/me` fiókonkénti `permissions` listájából — a menü, a gombok és a lapok
// EZEN kapuznak (a szerep NEVÉRE soha: a szerep tartalma a jogosultság-felületen szerkeszthető).
//
// A jog FIÓKONKÉNT érvényes (A-n felhasználó, B-n megtekintő), ezért két kérdés van:
//  • `has(perm)` — VAN-E bármely fiókon (a menüpont/gomb ettől látszik: ha egy fiókon használhatja, nem rejtjük);
//  • `hasInScope(perm, accountId)` — a sidebar fiók-scope-ján belül (`null` = „Minden fiók" → `has`).
// A UI-kapu csak UX: a fal a BFF-ben van, ami a fiókonkénti jogot minden végponton érvényesíti.
import type { PortalMeResponse } from '@atlas/contracts';
import type { PortalPermission } from '@atlas/shared';

import { usePortal } from '@/features/portal/portal-context';

export interface PortalPermissions {
  /** Még nincs keret-adat (a kapu ilyenkor NEM dönt: se elrejtés, se „nincs hozzáférés"). */
  isLoading: boolean;
  has: (perm: PortalPermission) => boolean;
  /** A jog a megadott scope-ban él-e (`null` = „Minden fiók"). */
  hasInScope: (perm: PortalPermission, accountId: string | null) => boolean;
  /** Azok a fiókok, amelyeken a jog megvan. */
  accountsWith: (perm: PortalPermission) => PortalMeResponse['accounts'];
}

/** Tiszta változat — ott használd, ahol a `me` prop-ként érkezik (sidebar, alsó nav), nem contextből. */
export function portalPermissionsOf(me: PortalMeResponse | undefined): PortalPermissions {
  const accountsWith = (perm: PortalPermission): PortalMeResponse['accounts'] =>
    (me?.accounts ?? []).filter((a) => a.permissions.includes(perm));
  return {
    isLoading: me === undefined,
    has: (perm) => accountsWith(perm).length > 0,
    hasInScope: (perm, accountId) =>
      accountId === null
        ? accountsWith(perm).length > 0
        : (me?.accounts ?? []).some((a) => a.id === accountId && a.permissions.includes(perm)),
    accountsWith,
  };
}

export function usePortalPermissions(): PortalPermissions {
  const { me } = usePortal();
  return portalPermissionsOf(me);
}
